var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 8.01589C16.6667 11.5225 13.3334 18.3334 10 18.3334C6.66671 18.3334 3.33337 11.5225 3.33337 8.01589C3.33337 4.50932 6.31814 1.66669 10 1.66669C13.6819 1.66669 16.6667 4.50932 16.6667 8.01589ZM10 11.6667C11.841 11.6667 13.3334 10.1743 13.3334 8.33335C13.3334 6.4924 11.841 5.00002 10 5.00002C8.15909 5.00002 6.66671 6.4924 6.66671 8.33335C6.66671 10.1743 8.15909 11.6667 10 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLocation);
export default __webpack_public_path__ + "static/media/menuLocation.66b00e0eddb90918aa2cf6aa48609360.svg";
export { ForwardRef as ReactComponent };